import { createSelector } from 'reselect'
import { selectIsFreemium, selectIsPaidAccount } from 'ducks/billing/selectors'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors/base'

import { selectIsInboxBootstrapped } from 'selectors/app/base'
import { selectKnownMailboxes } from './mailboxes_base'

const selectMailboxCountExclDemo = createSelector(
  selectIsInboxBootstrapped,
  selectKnownMailboxes,
  (bootstrapped, mailboxes) => {
    if (!bootstrapped) {
      return null
    }

    return (mailboxes || []).filter(mailbox => mailbox.state !== 'demo').length
  }
)

export const selectShowAddMailboxMessageCard = createSelector(
  selectCurrentUserIsAdminOrOwner,
  selectMailboxCountExclDemo,
  (isManager, mailboxCountExclDemo) => {
    return isManager && mailboxCountExclDemo === 0
  }
)

export const selectShowCallButton = createSelector(
  selectCurrentUserIsAdminOrOwner,
  selectShowAddMailboxMessageCard,
  selectIsPaidAccount,
  state => selectIsFreemium(state, 'inbox'),
  (isManager, showCard, isPaid, isFreemium) => {
    return isManager && !showCard && !isPaid && !isFreemium
  }
)
